var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{attrs:{"id":"zubehoer"}},[_c('ul',{staticClass:"form"},[_c('li',{staticClass:"non-flex"},[_c('h4',[_vm._v(_vm._s(_vm.$t('motor.sonderausstattung')))])]),_c('li',{staticClass:"non-flex"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('motor.hinweis')))])]),_c('p',[_vm._v(_vm._s(_vm.$t('motor.hinweis_text')))]),_c('ol',{staticClass:"beispiele"},[_c('li',[_vm._v(_vm._s(_vm.$t('motor.steuerkompass')))]),_c('li',[_vm._v(_vm._s(_vm.$t('motor.kuehleinrichtung')))]),_c('li',[_vm._v(_vm._s(_vm.$t('motor.herd')))]),_c('li',[_vm._v(_vm._s(_vm.$t('motor.tanks')))]),_c('li',[_vm._v(_vm._s(_vm.$t('motor.polster')))]),_c('li',[_vm._v(_vm._s(_vm.$t('motor.beleuchtung')))])]),_c('p',[_vm._v(_vm._s(_vm.$t('motor.zubehoer_text')))]),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('motor.zubehoer_text2')))])])]),_c('li',{staticStyle:{"margin-bottom":"2em"}},[_c('bootsprop',{attrs:{"label":_vm.$t('motor.motorisierung')}},[_c('el-select',{model:{value:(_vm.boot.motorisierung),callback:function ($$v) {_vm.$set(_vm.boot, "motorisierung", $$v)},expression:"boot.motorisierung"}},[_c('el-option',{attrs:{"label":_vm.$t('motor.motorisierung_standard'),"value":_vm.$t('motor.motorisierung_standard')}}),_c('el-option',{attrs:{"label":_vm.$t('motor.motorisierung_mehr'),"value":_vm.$t('motor.motorisierung_mehr')}}),_c('el-option',{attrs:{"label":_vm.$t('motor.motorisierung_aussen'),"value":_vm.$t('motor.motorisierung_aussen')}})],1)],1),_c('bootsprop',{attrs:{"label":_vm.$t('motor.anzahl_motoren')}},[_c('el-select',{model:{value:(_vm.boot.anzahl_motoren),callback:function ($$v) {_vm.$set(_vm.boot, "anzahl_motoren", $$v)},expression:"boot.anzahl_motoren"}},_vm._l((4),function(h,index){return _c('el-option',{key:index,attrs:{"label":h,"value":h}})}),1)],1),_c('bootsprop',{attrs:{"label":_vm.$t('motor.leistung_kw')}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.boot.leistung_kw),expression:"boot.leistung_kw"}],domProps:{"value":(_vm.boot.leistung_kw)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.boot, "leistung_kw", $event.target.value)}}})]),_c('bootsprop',{attrs:{"label":_vm.$t('motor.alter')}},[_c('el-select',{model:{value:(_vm.boot.motorisierung_alter),callback:function ($$v) {_vm.$set(_vm.boot, "motorisierung_alter", $$v)},expression:"boot.motorisierung_alter"}},_vm._l((_vm.alterOptions),function(h,index){return _c('el-option',{key:index,attrs:{"label":(h + " " + (_vm.$t('motor.jahre'))),"value":h}})}),1)],1)],1),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.dph'),
				name: 'dph',
				value: _vm.boot.dph,
				alter: _vm.boot.dph_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.sonderfarbe'),
				name: 'sonderfarbe',
				value: _vm.boot.sonderfarbe,
				alter: _vm.boot.sonderfarbe_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.bugstrahlruder'),
				name: 'bugstrahlruder',
				value: _vm.boot.bugstrahlruder,
				alter: _vm.boot.bugstrahlruder_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.anker'),
				name: 'anker',
				value: _vm.boot.anker,
				alter: _vm.boot.anker_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.ankerwinsch'),
				name: 'ankerwinsch',
				value: _vm.boot.ankerwinsch,
				alter: _vm.boot.ankerwinsch_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.teak_cockpit'),
				name: 'teak_cockpit',
				value: _vm.boot.teak_cockpit,
				alter: _vm.boot.teak_cockpit_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.teak_laufdeck'),
				name: 'teak_laufdeck',
				value: _vm.boot.teak_laufdeck,
				alter: _vm.boot.teak_laufdeck_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.flexiTeek_cockpit'),
				name: 'flexiTeek_cockpit',
				value: _vm.boot.flexiTeek_cockpit,
				alter: _vm.boot.flexiTeek_cockpit_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.flexiTeek_laufdeck'),
				name: 'flexiTeek_laufdeck',
				value: _vm.boot.flexiTeek_laufdeck,
				alter: _vm.boot.flexiTeek_laufdeck_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.kork'),
				name: 'kork',
				value: _vm.boot.kork,
				alter: _vm.boot.kork_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.sonnenpolster'),
				name: 'sonnenpolster',
				value: _vm.boot.sonnenpolster,
				alter: _vm.boot.sonnenpolster_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.bimini'),
				name: 'bimini',
				value: _vm.boot.bimini,
				alter: _vm.boot.bimini_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.camperverdeck'),
				name: 'camperverdeck',
				value: _vm.boot.camperverdeck,
				alter: _vm.boot.camperverdeck_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.hafenpersenning'),
				name: 'hafenpersenning',
				value: _vm.boot.hafenpersenning,
				alter: _vm.boot.hafenpersenning_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.cockpittisch_Sitzgruppe'),
				name: 'cockpittisch_Sitzgruppe',
				value: _vm.boot.cockpittisch_Sitzgruppe,
				alter: _vm.boot.cockpittisch_Sitzgruppe_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.cockpittisch'),
				name: 'cockpittisch',
				value: _vm.boot.cockpittisch,
				alter: _vm.boot.cockpittisch_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.cockpitkuehlschrank'),
				name: 'cockpitkuehlschrank',
				value: _vm.boot.cockpitkuehlschrank,
				alter: _vm.boot.cockpitkuehlschrank_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.badeplattform'),
				name: 'badeplattform',
				value: _vm.boot.badeplattform,
				alter: _vm.boot.badeplattform_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.seetoilette'),
				name: 'seetoilette',
				value: _vm.boot.seetoilette,
				alter: _vm.boot.seetoilette_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.warmluftheizung'),
				name: 'warmluftheizung',
				value: _vm.boot.warmluftheizung,
				alter: _vm.boot.warmluftheizung_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.klimaanlage'),
				name: 'klimaanlage',
				value: _vm.boot.klimaanlage,
				alter: _vm.boot.klimaanlage_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.dieselgenerator'),
				name: 'dieselgenerator',
				value: _vm.boot.dieselgenerator,
				alter: _vm.boot.dieselgenerator_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.landstromanschluss'),
				name: 'landstromanschluss',
				value: _vm.boot.landstromanschluss,
				alter: _vm.boot.landstromanschluss_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.wechselrichter'),
				name: 'wechselrichter',
				value: _vm.boot.wechselrichter,
				alter: _vm.boot.wechselrichter_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.audioanlage'),
				name: 'audioanlage',
				value: _vm.boot.audioanlage,
				alter: _vm.boot.audioanlage_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.sprechfunk'),
				name: 'sprechfunk',
				value: _vm.boot.sprechfunk,
				alter: _vm.boot.sprechfunk_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.kartenplotter'),
				name: 'kartenplotter',
				value: _vm.boot.kartenplotter,
				alter: _vm.boot.kartenplotter_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.autopilot'),
				name: 'autopilot',
				value: _vm.boot.autopilot,
				alter: _vm.boot.autopilot_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.radar'),
				name: 'radar',
				value: _vm.boot.radar,
				alter: _vm.boot.radar_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.echolot'),
				name: 'echolot',
				value: _vm.boot.echolot,
				alter: _vm.boot.echolot_alter,
			}},on:{"changed":_vm.handlePropChange}}),_c('checkprop',{attrs:{"bprop":{
				label: _vm.$t('motor.sumlog'),
				name: 'sumlog',
				value: _vm.boot.sumlog,
				alter: _vm.boot.sumlog_alter,
			}},on:{"changed":_vm.handlePropChange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }